import { render, staticRenderFns } from "./transferFile.vue?vue&type=template&id=5bf1fad6&scoped=true&lang=html&"
import script from "./transferFile.vue?vue&type=script&lang=js&"
export * from "./transferFile.vue?vue&type=script&lang=js&"
import style0 from "./transferFile.vue?vue&type=style&index=0&id=5bf1fad6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1fad6",
  null
  
)

component.options.__file = "transferFile.vue"
export default component.exports